import DropdownMenuItem from "../../../../../../design-system/components/DropdownMenu/DropdownMenuItem.jsx";

function GroupNameEditButton({ smallTeamId }) {
  function handleClick() {
    const element = document.getElementById(`${smallTeamId}-group-name`);

    if (element) {
      element.focus();
    }
  }

  return (
    <DropdownMenuItem icon="edit" onClick={handleClick}>
      Gruppenname ändern
    </DropdownMenuItem>
  );
}

export default GroupNameEditButton;
